const wishlistTypes = {
  TOGGLE_ITEM: 'TOGGLE_ITEM',
  CLEAR_WISH_LIST: 'CLEAR_WISH_LIST',
  SET_LIST_FROM_FIREBASE: 'SET_LIST_FROM_FIREBASE',
  UPDATE_LIST_IN_FIREBASE: 'UPDATE_LIST_IN_FIREBASE'
};

export default wishlistTypes;
